import { Control } from '@yleisradio/areena-types';
import classNames from 'classnames';
import { MenuItem } from './MenuItem';
import styles from './MenuList.module.scss';
import { FunctionComponent } from 'react';

type Props = {
  controls: Control[];
  groupTag: string | undefined;
  toggleSubMenu: () => void;
};

export const MenuList: FunctionComponent<Props> = ({
  controls,
  groupTag,
  toggleSubMenu,
}) => {
  if (controls && controls.length > 0)
    return (
      <ul
        className={classNames(
          styles.menuList,
          groupTag === 'channels' && styles.channels,
          groupTag === 'shortcuts' && styles.shortcuts
        )}
      >
        {controls.map((control: Control) => (
          <MenuItem
            key={control.title}
            item={control}
            toggleSubMenu={toggleSubMenu}
          />
        ))}
      </ul>
    );
  else return null;
};
